import { doFetch } from "./ConnectionManager";

function toJsonOrNull(response) {
  if (!response || !response.ok) return null;
  return response.json().catch(() => null);
}

export async function getIncidentMyRole() {
  const response = await doFetch("CUBE", "incidencias/my-role", { method: "GET", _silent: true });
  const json = await toJsonOrNull(response);
  return json?.DATA || { isManager: false, isBackdoor: false };
}

export async function createIncident(payload = {}) {
  const response = await doFetch("CUBE", "incidencias/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const json = await response?.json?.().catch(() => null);
  return { ok: !!response?.ok, status: response?.status, json };
}

export async function getMyIncidents({ appCode } = {}) {
  const params = new URLSearchParams();
  if (appCode) params.set("appCode", String(appCode));
  const suffix = params.toString() ? `?${params.toString()}` : "";

  const response = await doFetch("CUBE", `incidencias/mine${suffix}`, { method: "GET", _silent: true });
  if (response && (response.status === 401 || response.status === 403)) {
    const denied = await response.json().catch(() => null);
    throw new Error(denied?.MESSAGE || "No se pudieron consultar tus incidencias");
  }
  const json = await toJsonOrNull(response);
  return Array.isArray(json?.DATA) ? json.DATA : [];
}

export async function getIncidentDetail(idIncidencia) {
  const response = await doFetch("CUBE", `incidencias/${idIncidencia}`, { method: "GET", _silent: true });
  const json = await toJsonOrNull(response);
  return json?.DATA || null;
}

export async function addIncidentMessage(idIncidencia, payload = {}) {
  const response = await doFetch("CUBE", `incidencias/${idIncidencia}/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const json = await response?.json?.().catch(() => null);
  return { ok: !!response?.ok, status: response?.status, json };
}

export async function resolveIncidentByUser(idIncidencia) {
  const response = await doFetch("CUBE", `incidencias/${idIncidencia}/resolve`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });
  const json = await response?.json?.().catch(() => null);
  return { ok: !!response?.ok, status: response?.status, json };
}

export async function getManageIncidents({ status, appCode, assignedUserId, creatorUserId, priority, search } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", String(status));
  if (appCode) params.set("appCode", String(appCode));
  if (assignedUserId != null) params.set("assignedUserId", String(assignedUserId));
  if (creatorUserId != null) params.set("creatorUserId", String(creatorUserId));
  if (priority) params.set("priority", String(priority));
  if (search) params.set("search", String(search));
  const suffix = params.toString() ? `?${params.toString()}` : "";

  const response = await doFetch("CUBE", `incidencias/manage/list${suffix}`, { method: "GET", _silent: true });
  if (response && response.status === 403) {
    const denied = await response.json().catch(() => null);
    throw new Error(denied?.MESSAGE || "No tienes permisos de gestor de incidencias");
  }
  const json = await toJsonOrNull(response);
  return Array.isArray(json?.DATA) ? json.DATA : [];
}

export async function updateIncidentStatus(idIncidencia, status) {
  const response = await doFetch("CUBE", `incidencias/${idIncidencia}/status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  });
  const json = await response?.json?.().catch(() => null);
  return { ok: !!response?.ok, status: response?.status, json };
}

export async function assignIncident(idIncidencia, assignedUserId) {
  const response = await doFetch("CUBE", `incidencias/${idIncidencia}/assign`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ assignedUserId }),
  });
  const json = await response?.json?.().catch(() => null);
  return { ok: !!response?.ok, status: response?.status, json };
}

export async function getAllExceptions({
  page = 1,
  pageSize = 50,
  appCode,
  className,
  methodName,
  userId,
  message,
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  if (appCode) params.set("appCode", String(appCode));
  if (className) params.set("className", String(className));
  if (methodName) params.set("methodName", String(methodName));
  if (userId != null && userId !== "") params.set("userId", String(userId));
  if (message) params.set("message", String(message));
  const response = await doFetch("CUBE", `getAllExceptions?${params.toString()}`, { method: "GET", _silent: true });
  if (response && response.status === 403) {
    const denied = await response.json().catch(() => null);
    throw new Error(denied?.MESSAGE || "No tienes permisos para consultar exceptions");
  }
  const json = await toJsonOrNull(response);
  return {
    rows: Array.isArray(json?.DATA) ? json.DATA : [],
    page: Number(json?.PAGE || page) || 1,
    pageSize: Number(json?.PAGE_SIZE || pageSize) || 50,
    totalRows: Number(json?.TOTAL_ROWS || 0) || 0,
    totalPages: Number(json?.TOTAL_PAGES || 0) || 0,
  };
}

export async function getDebugLogRules({ enabled, sourceProject, nameContains } = {}) {
  const params = new URLSearchParams();
  if (enabled !== undefined && enabled !== null && enabled !== "") {
    params.set("enabled", String(enabled));
  }
  if (sourceProject) params.set("sourceProject", String(sourceProject));
  if (nameContains) params.set("nameContains", String(nameContains));

  const suffix = params.toString() ? `?${params.toString()}` : "";
  const response = await doFetch("CUBE", `getDebugLogRules${suffix}`, { method: "GET", _silent: true });
  if (response && response.status === 403) {
    const denied = await response.json().catch(() => null);
    throw new Error(denied?.MESSAGE || "No tienes permisos para consultar reglas de logs");
  }
  const json = await toJsonOrNull(response);
  return Array.isArray(json?.DATA) ? json.DATA : [];
}

export async function upsertDebugLogRule(payload = {}) {
  const response = await doFetch("CUBE", "upsertDebugLogRule", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const json = await response?.json?.().catch(() => null);
  return { ok: !!response?.ok, status: response?.status, json };
}

export async function deleteDebugLogRule(idRule) {
  const response = await doFetch("CUBE", `deleteDebugLogRule?IDRule=${encodeURIComponent(idRule)}`, {
    method: "DELETE",
  });
  const json = await response?.json?.().catch(() => null);
  return { ok: !!response?.ok, status: response?.status, json };
}

export async function getDebugLogs({
  page = 1,
  pageSize = 50,
  sourceProject,
  className,
  methodName,
  userId,
  userName,
  levelName,
  ruleId,
  message,
  fromDate,
  toDate,
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  if (sourceProject) params.set("sourceProject", String(sourceProject));
  if (className) params.set("className", String(className));
  if (methodName) params.set("methodName", String(methodName));
  if (userId != null && userId !== "") params.set("userId", String(userId));
  if (userName) params.set("userName", String(userName));
  if (levelName) params.set("levelName", String(levelName));
  if (ruleId != null && ruleId !== "") params.set("ruleId", String(ruleId));
  if (message) params.set("message", String(message));
  if (fromDate) params.set("fromDate", String(fromDate));
  if (toDate) params.set("toDate", String(toDate));

  const response = await doFetch("CUBE", `getDebugLogs?${params.toString()}`, { method: "GET", _silent: true });
  if (response && response.status === 403) {
    const denied = await response.json().catch(() => null);
    throw new Error(denied?.MESSAGE || "No tienes permisos para consultar logs");
  }
  const json = await toJsonOrNull(response);
  return {
    rows: Array.isArray(json?.DATA) ? json.DATA : [],
    page: Number(json?.PAGE || page) || 1,
    pageSize: Number(json?.PAGE_SIZE || pageSize) || 50,
    totalRows: Number(json?.TOTAL_ROWS || 0) || 0,
    totalPages: Number(json?.TOTAL_PAGES || 0) || 0,
  };
}

export async function deleteDebugLogs(payload = {}) {
  const response = await doFetch("CUBE", "deleteDebugLogs", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const json = await response?.json?.().catch(() => null);
  return { ok: !!response?.ok, status: response?.status, json };
}
